import { render, staticRenderFns } from "./LecturerChat.vue?vue&type=template&id=04568f5b&"
import script from "./LecturerChat.vue?vue&type=script&lang=js&"
export * from "./LecturerChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports